import cabanaWater from "@/assets/cabanas-water-view.jpg";
import cabanaDock from "@/assets/cabana-dock-view.jpg";
import cabanaInterior from "@/assets/cabana-interior.jpg";
import cabanaHammock from "@/assets/cabana-hammock.jpg";

const photos = [
  { src: cabanaWater, alt: "Private waterfront cabana on Lake Placid", label: "Area A - Cabanas" },
  { src: cabanaDock, alt: "Cabana with private dock and swim ladder", label: "Key Cabanas" },
  { src: cabanaInterior, alt: "Inside a Son's Island cabana", label: "Area B - Cabanas" },
  { src: cabanaHammock, alt: "Hammock at a waterfront cabana", label: "Area C - Cabanas" },
];

const CabanasOverviewSection = () => {
  return (
    <section
      id="cabanas"
      style={{ scrollMarginTop: "96px" }}
      className="scroll-mt-24 py-16 md:py-20 bg-muted/30"
    >
      <div className="container mx-auto px-4">
        <div className="text-center mb-10 max-w-3xl mx-auto">
          <h2 className="font-serif text-3xl md:text-4xl text-foreground mb-3">A Cabana Rental is Required to Enter Son's Island</h2>
          <p className="text-lg text-muted-foreground">
            55 private waterfront cabanas, each with its own private dock and swim ladder.
            One cabana reserves entry for up to 8 guests (15 max).
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {photos.map((p) => (
            <div key={p.src} className="text-center">
              <div className="aspect-[4/3] overflow-hidden rounded-xl">
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
              <p className="mt-2 text-sm font-medium text-foreground">{p.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CabanasOverviewSection;